import {
  CreateFieldInput,
  CreateFieldSelect,
  CreateFieldTextarea,
  CreateFormActions,
  CreateNextSteps,
  PageTitle
} from '../../components.js';
import { Page } from '../base.js';

export class SupportCreate extends Page {
  static statusOptions = [
    { value: 'open', label: 'Open' },
    { value: 'inProgress', label: 'In Progress' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'closed', label: 'Closed' }
  ];

  static priorityOptions = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'urgent', label: 'Urgent' }
  ];

  static nextSteps = [
    { icon: 'users', label: 'Assign the ticket' },
    { icon: 'mail', label: 'Contact the requester' },
    { icon: 'settings', label: 'Update its priority' },
    { icon: 'check', label: 'Track it through resolution' }
  ];

  static timlComponents = {
    CreateFieldInput,
    CreateFieldSelect,
    CreateFieldTextarea,
    CreateFormActions,
    CreateNextSteps,
    PageTitle
  };

  static get formAction() {
    return API.resourceUrl('support');
  }

  static timl = `
    .auth-create-page.support-create-page
      <PageTitle title="Create Support Ticket">
      .auth-create-content
        p.auth-create-description Create a support ticket and capture everything needed to resolve it.
        .create-page-grid
          form.create-form-card[method="POST" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/support"]
            .create-form-body
              <CreateFieldInput label="Subject" name="subject" placeholder="Briefly describe the issue" hint="Use a short, specific summary.">
              <CreateFieldTextarea label="Message" name="message" placeholder="Describe what happened and what you expected" rows="8">
              <CreateFieldSelect label="Status" name="status" options="{{ Routing.routeObject.statusOptions }}" value="open">
              <CreateFieldSelect label="Priority" name="priority" options="{{ Routing.routeObject.priorityOptions }}" value="medium">
            <CreateFormActions submitLabel="Create ticket" cancelHref="/support">
          <CreateNextSteps items="{{ Routing.routeObject.nextSteps }}">
  `;
}
